<script>
import TableFooter from 'dashboard/components/widgets/TableFooter.vue';
import SLAReportItem from './SLAReportItem.vue';
import Skeleton from 'dashboard/components-next/skeleton/Skeleton.vue';
import EmptyState from 'dashboard/components-next/empty-state/EmptyState.vue';
export default {
  name: 'SLATable',
  components: {
    SLAReportItem,
    TableFooter,
    Skeleton,
    EmptyState,
  },
  props: {
    slaReports: {
      type: Array,
      default: () => [],
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 25,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['pageChange'],
  data() {
    return {
      pageNo: 1,
    };
  },
  computed: {
    shouldShowFooter() {
      return this.currentPage === 1
        ? this.totalCount > this.pageSize
        : this.slaReports.length > 0;
    },
  },
  methods: {
    onPageChange(page) {
      this.$emit('pageChange', page);
    },
  },
};
</script>

<template>
  <div>
    <div
      class="min-w-full bg-n-solid-1 dark:bg-n-solid-2 border border-n-weak os-r-xl os-elev-1 p-6"
    >
      <!--
        Header row — refined to canonical uppercase micro-tracked typography.
        Grid layout preserved verbatim; only the cell typography changed.
      -->
      <div
        class="grid content-center h-10 grid-cols-12 gap-4 px-4 py-0 bg-n-alpha-2 os-r-md"
      >
        <div class="col-span-6 text-[11px] font-semibold uppercase tracking-[0.04em] text-n-slate-11">
          {{ $t('SLA_REPORTS.TABLE.HEADER.CONVERSATION') }}
        </div>
        <div class="col-span-2 text-[11px] font-semibold uppercase tracking-[0.04em] text-n-slate-11">
          {{ $t('SLA_REPORTS.TABLE.HEADER.POLICY') }}
        </div>
        <div class="col-span-2 text-[11px] font-semibold uppercase tracking-[0.04em] text-n-slate-11">
          {{ $t('SLA_REPORTS.TABLE.HEADER.AGENT') }}
        </div>
        <div class="col-span-1" />
      </div>

      <!-- Skeleton table rows while data is streaming -->
      <div
        v-if="isLoading"
        class="flex flex-col gap-3 p-4"
        role="status"
        aria-busy="true"
        :aria-label="$t('SLA_REPORTS.LOADING')"
      >
        <Skeleton v-for="i in 5" :key="i" variant="table-row" />
      </div>

      <!-- Live rows — SLAReportItem rendering chain unchanged -->
      <div v-else-if="slaReports.length > 0">
        <SLAReportItem
          v-for="slaReport in slaReports"
          :key="slaReport.applied_sla.id"
          :sla-name="slaReport.applied_sla.sla_name"
          :conversation="slaReport.conversation"
          :conversation-id="slaReport.conversation.id"
          :sla-events="slaReport.sla_events"
        />
      </div>

      <!-- Canonical empty state with semantic icon -->
      <EmptyState
        v-else
        icon="i-lucide-clock-alert"
        :title="$t('SLA_REPORTS.NO_RECORDS')"
        variant="compact"
      />
    </div>
    <TableFooter
      v-if="shouldShowFooter"
      :current-page="currentPage"
      :total-count="totalCount"
      :page-size="pageSize"
      @page-change="onPageChange"
    />
  </div>
</template>
